import { centerTagChip } from './academyTagRail';

/**
 * 검색 영역 동작 두 가지.
 *
 *   1. 정렬·계정 드롭다운에서 무언가를 고르면 바로 검색한다.
 *      (드롭다운 안의 라디오·체크박스가 올린 change 가 여기까지 올라온다.)
 *   2. 선택된 태그가 태그 줄 밖에 있으면 보이도록 가로 스크롤한다.
 *
 * 폼은 JS 없이도 '검색' 버튼과 태그 링크로 동작한다. 여기서는 손이 덜 가게 할 뿐이라
 * 스크립트가 실패해도 기능이 사라지지 않는다.
 */
const InitAcademyFilters = () => {
  const form = document.querySelector('.academy-filters__form');

  if (form) {
    form.querySelectorAll('[data-academy-filter]').forEach((control) => {
      control.addEventListener('change', () => {
        // requestSubmit 이어야 submit 이벤트가 발생한다. form.submit() 은 핸들러를
        // 건너뛰어 결과 영역만 갈아끼우는 처리가 통째로 무시된다.
        form.requestSubmit();
      });
    });
  }

  // 태그가 많으면 선택한 칩이 화면 밖에 있을 수 있다. 지금 무엇이 켜져 있는지
  // 보이지 않으면 목록이 왜 걸러졌는지 알 수 없으므로 가운데로 끌어온다.
  document.querySelectorAll('.academy-tags').forEach((rail) => {
    const active = rail.querySelector('.is-active');
    const railBox = rail.getBoundingClientRect();
    const chipBox = active?.getBoundingClientRect();

    if (!active || (chipBox.left >= railBox.left && chipBox.right <= railBox.right)) {
      return; // 선택이 없거나 이미 다 보인다
    }

    centerTagChip(active);
  });
};

export default InitAcademyFilters;
